module.exports = __webpack_public_path__ + "static/img/6_1.3f88ee52.jpg";